import { forwardRef } from 'react';
import { createPortal } from 'react-dom';
import type { PropsWithoutRef } from 'react';
import styled from 'styled-components';

import type { RefElement, WithAttributes } from '../../types';
import { useConfiguration } from '../../hooks';

type HiddenTextProps = WithAttributes<
  'span',
  {
    /** A DOM id that other elements can reference for an accessible label/description text. */
    id: string;
    /** Text content for an accessible label/description. */
    children: string;
  }
>;

export const StyledHiddenText = styled.span`
  display: none;
`;

export default forwardRef<RefElement<HiddenTextProps>, PropsWithoutRef<HiddenTextProps>>(
  function HiddenText(props, ref) {
    const { portalTarget } = useConfiguration();

    return portalTarget
      ? createPortal(<StyledHiddenText {...props} ref={ref} />, portalTarget)
      : null;
  }
);
